import React from 'react';
import { FilterOption } from '@css-xp/graphtypes/src/generated-types-sxp';
import { useFetchInvoicesForTransactionAccountPPCQuery } from '@css-xp/ppc-api';
import { useFetchBillingProfilesForTransactionAccountQuery } from '@css-xp/ppc-billing-profile-table';
import { useFetchQuotesForTransactionAccount } from '@css-xp/ppc-quote-table';
import { INVOICE_TABLE_UTILS } from '@css-xp/ppc-utils';
import { defaultBillingProfileSortOptions } from '@css-xp/ppc-constants';

interface CacheCustomerAddressDetailTabGraphqlQueryProps {
  soldToAddressIds: string[];
  transactionAccountId: string;
  quoteFilterOptions: FilterOption;
  invoiceFilterOptions: Record<string, string>[];
}

export const CacheCustomerAddressDetailTabGraphqlQuery = ({
  soldToAddressIds,
  transactionAccountId,
  quoteFilterOptions,
  invoiceFilterOptions,
}: CacheCustomerAddressDetailTabGraphqlQueryProps) => {
  useFetchQuotesForTransactionAccount({ transactionAccountId, filterOptions: quoteFilterOptions });
  useFetchBillingProfilesForTransactionAccountQuery({
    soldToAddressIds: soldToAddressIds,
    transactionAccountId: transactionAccountId,
    sortOptions: defaultBillingProfileSortOptions,
  });
  useFetchInvoicesForTransactionAccountPPCQuery({
    txaId: transactionAccountId,
    filterOptions: INVOICE_TABLE_UTILS.getFilterOptions({ filters: invoiceFilterOptions }),
  });
  return null;
};
